import { ref } from 'vue'

export function useUpgradeModal() {
  const isUpgradeModalOpen = ref(false)
  const requiredPlanForFeature = ref('')

  function openUpgradeModal(plan: string) {
    requiredPlanForFeature.value = plan
    isUpgradeModalOpen.value = true
  }

  return {
    isUpgradeModalOpen,
    requiredPlanForFeature,
    openUpgradeModal,
  }
}
